import { createAction } from 'redux-act';

import { IVerifiedAddressOption } from '../../types/Shipping.types';

import { IAddressRequestPayload } from './address.types';

const PREFIX = 'RECIPIENT/ADDRESS';

export const loadAddressRequest = createAction<IAddressRequestPayload>(`${PREFIX}/LOAD_ADDRESS_REQUEST`);
export const loadAddressSuccess = createAction<IVerifiedAddressOption[]>(`${PREFIX}/LOAD_ADDRESS_SUCCESS`);
export const loadAddressFail = createAction(`${PREFIX}/LOAD_ADDRESS_FAIL`);
